import { studioByID, studioCreate, studioDestroy, studioUpdate, studiosList } from '@/services/agency/showcaseStudios.service'

export default {
	namespaced: true,
	state: {
		// SHOWCASES STUDIOS
		studiosList: {
			data: [],
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		studio: {},
		// STATUS SHOWCASES STUDIOS
		studiosStatus: 'pending',
		studiosSaveStatus: 'init',
		studiosDeleteStatus: 'init',
	},
	getters: {
		// SHOWCASES STUDIOS
		getStudiosList(state) {
			return state.studiosList
		},
		getStudio(state) {
			return state.studio
		},
		// SHOWCASES STUDIOS
		getStudiosDeleteStatus(state) {
			return state.studiosDeleteStatus
		},
		getStudiosSaveStatus(state) {
			return state.studiosSaveStatus
		},
		getStudiosStatus(state) {
			return state.studiosStatus
		},
	},
	mutations: {
		// SHOWCASES STUDIOS
		STUDIOS_LIST(state, value) {
			state.studiosList = value
		},
		SET_STUDIO(state, value) {
			state.studio = value
		},
		// STATUS SHOWCASES STUDIOS
		STUDIOS_STATUS(state, value) {
			state.studiosStatus = value
		},
		STUDIO_SAVE_STATUS(state, value) {
			state.studiosSaveStatus = value
		},
		STUDIO_DELETE_STATUS(state, value) {
			state.studiosDeleteStatus = value
		},
	},
	actions: {
		// SHOWCASES Studios
		async fetchStudioList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('STUDIOS_STATUS', 'pending')
			commit('STUDIOS_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const merged = { per_page: 'all', ...params }
				const { data } = await studiosList(merged)
				commit('STUDIOS_STATUS', 'init')
				commit('STUDIOS_LIST', data)
				return data
			} catch (error) {
				commit('STUDIOS_STATUS', 'init')
				throw error
			}
		},
		async fetchStudioByID({ commit }, params) {
			commit('STUDIOS_STATUS', 'pending')
			try {
				const { data } = await studioByID(params)
				commit('STUDIOS_STATUS', 'init')
				commit('SET_STUDIO', data.data)
				return data
			} catch (error) {
				commit('STUDIOS_STATUS', 'init')

				return error
			}
		},
		async saveNewStudio({ commit }, params) {
			commit('STUDIO_SAVE_STATUS', 'pending')
			try {
				const { data } = await studioCreate(params)
				commit('STUDIO_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STUDIO_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateStudio({ commit }, params) {
			commit('STUDIO_SAVE_STATUS', 'pending')
			try {
				const { data } = await studioUpdate(params)
				commit('STUDIO_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STUDIO_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteStudioByID({ commit }, params) {
			commit('STUDIO_DELETE_STATUS', 'pending')
			try {
				const { data } = await studioDestroy(params)
				commit('STUDIO_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('STUDIO_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
